import { ChangeDetectionStrategy, Component, input, OnChanges, output, SimpleChanges, } from '@angular/core';

@Component({
    selector: 'app-search-input',
    templateUrl: './search-input.component.html',
    styleUrl: './search-input.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInputComponent implements OnChanges {
  value:string = '';
  readonly placeholder = input('Search');
  readonly search = output<string>();
  readonly searchText = input<string>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchText']) {
      this.value = changes['searchText'].currentValue ?? '';
    }
  }

  onSearchClick(){
    this.search.emit(this.value);
  }

  clear(){
    this.value ='';
  }
}
